"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  update: true,
  stepStatus: true
};
exports.stepStatus = stepStatus;
exports.update = update;
var _submission = require("../submission");
var _extras = require("../extras");
var _DumbappResult = require("./DumbappResult");
Object.keys(_DumbappResult).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DumbappResult[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappResult[key];
    }
  });
});
var _EthExecutor = require("./EthExecutor");
Object.keys(_EthExecutor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _EthExecutor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EthExecutor[key];
    }
  });
});
var _ExecutorBase = require("./ExecutorBase");
Object.keys(_ExecutorBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ExecutorBase[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ExecutorBase[key];
    }
  });
});
var _DumbappGasEstimate = require("./DumbappGasEstimate");
Object.keys(_DumbappGasEstimate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DumbappGasEstimate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappGasEstimate[key];
    }
  });
});
var _ExecutorParameters = require("./ExecutorParameters");
Object.keys(_ExecutorParameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ExecutorParameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ExecutorParameters[key];
    }
  });
});
/**
 * Returns a new DumbappSubmission with updates.
 *
 * Return value also has flags for if the submission was just completed or had an error.
 *
 * If nothing has changed, returns null.
 */
async function update(provider, submission, parameters) {
  if (!submission.data.pending()) {
    // Not pending, no update needed
    return null;
  }
  try {
    let wallet = await provider.get(submission.type, parameters);
    let res = await wallet.updateStatus(submission);
    if (res.success === true) {
      if (!res.data) {
        // Return null to indicate no changes
        return null;
      }
      if (!submission.data.completed() && res.data.completed()) {
        res.completed = true;
        let extras = await (0, _extras.addExtras)(parameters, new _submission.DumbappSubmission(submission.dumbapp, res.data));
        res.data.extras = Object.assign(res.data.extras || {}, extras);
      }
      if (!submission.data.error() && res.data.error()) {
        res.failed = true;
      }
    }
    return res;
  } catch (err) {
    return {
      success: false,
      code: "unknown",
      message: err.message,
      errorData: err
    };
  }
}
function stepStatus(step) {
  if (step.status === "confirm") {
    return {
      text: "Waiting For MetaMask",
      class: "waiting",
      icon: "pending"
    };
  }
  if (step.pendingConfirmation() || step.status === "new") {
    return {
      text: "Waiting",
      class: "waiting",
      icon: "pending"
    };
  }
  if (step.status === "unknown") {
    return {
      text: "Unknown",
      class: "unknown",
      icon: "warning"
    };
  }
  if (step.pending()) {
    return {
      text: "Pending...",
      class: "pending",
      progress: true
    };
  }
  if (step.status === "error") {
    return {
      text: "Failed",
      class: "failed",
      icon: "error"
    };
  }
  if (step.completed()) {
    return {
      text: "Success",
      class: "confirmed",
      icon: "check_circle"
    };
  }
  return {};
}
//# sourceMappingURL=index.js.map